import React, {Fragment} from "react";
import {FormattedMessage} from "react-intl";

import LookMainHeaderCloseButton from "./lookMainHeaderCloseButton";

// import {LookExpandIcon, LookMinimizeIcon} from "../../../common/icons";
// import SvgIcon from "@mui/material/SvgIcon";
// import LookViewTypeSwitcher from "./lookViewTypeSwitcher";

const LookMainHeader = () => {

  // const {intl, lookOpened, lookExpanded, lookViewType, setLookExpanded, isMobile, history, setLookOpened} = props;

  // const expandButtonClick = () => {
  //   setLookExpanded(!lookExpanded)
  // };

  return (
    <Fragment>
      <span className="lm-header__title"><FormattedMessage id="look.header"/></span>
      <div className="lm-header__buttons">
        {/*<LookViewTypeSwitcher/>*/}
        {/*<IconButton aria-label={intl.formatMessage({id:"tooltip.editLook"})}*/}
        {/*            disabled={lookViewType !== 1}*/}
        {/*            className="look-icon look-icon--small look-icon--white"*/}
        {/*            onClick={expandButtonClick}>*/}
        {/*  <SvgIcon style={{ fontSize: 22 }}>*/}
        {/*    {lookExpanded ? <LookMinimizeIcon/> : <LookExpandIcon/>}*/}
        {/*  </SvgIcon>*/}
        {/*</IconButton>*/}
        <LookMainHeaderCloseButton/>
      </div>
    </Fragment>
  )
};

export default LookMainHeader
